import React from "react"
import Badge from "design_system/core/components/badge"
import routes from "@love-irish/routes"

import "./topic_badge.css"
import { cn } from "design_system/libs"

export const TopicBadge = ({ topic, className }) => (
  <Badge
    variant="outline"
    as="a"
    href={topic.path || routes.topicPath(topic.slug)}
    className={cn("topic-badge", className)}
    style={
      topic.color
        ? ({ "--topic-color": topic.color } as React.CSSProperties)
        : undefined
    }
  >
    {topic.color && (
      <span
        className="w-3 h-3 rounded-full"
        style={{ backgroundColor: topic.color }}
      />
    )}
    #{topic.slug}
  </Badge>
)

export default TopicBadge
